import { editorDomainMetaIsOn } from "./editorDomainMetaIsOn";

/**
 * Whether this document is the hidden preload iframe rather than a real editor.
 *
 * `preload.html.erb` is the only page that sets this meta. The iframe exists to warm the editor
 * origin's bundle, and it renders nothing anybody sees, so any request it makes is waste.
 */
export const isEditorDomainPreload = (): boolean => editorDomainMetaIsOn("in-editor-domain-preload");
